<ng-container>
  <div class="formControl financial mt">
    <div class="grid-col-2 grid">
      <div class="">
        <div>
          <pr-image-viewer
            imageURL="assets/svg/ressources/risk_gambiling_choise_d_cas_a1.svg"
            [open]="viewerOpen1"
            (close)="viewerOpen1 = false"
          ></pr-image-viewer>
          <img
            (click)="viewerOpen1 = true"
            src="assets/svg/ressources/risk_gambiling_choise_d_cas_a1.svg"
          />
        </div>
      </div>
      <div class="">
        <div>
          <pr-image-viewer
            imageURL="assets/svg/ressources/risk_gambiling_choise_d_cas_b1.svg"
            [open]="viewerOpen2"
            (close)="viewerOpen2 = false"
          ></pr-image-viewer>
          <img
            (click)="viewerOpen2 = true"
            src="assets/svg/ressources/risk_gambiling_choise_d_cas_b1.svg"
          />
        </div>
      </div>
    </div>
  </div>
</ng-container>

<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="riskProfil">
                <financial-knowledge8
                  [derrors]="derrors"
                ></financial-knowledge8>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
